import { useEffect } from 'react'
import { Error, Loader, DisplayExamDate } from '../../../common'
import { selectSelectedApprovalRequest } from '../../../../selectors/approvalRequests'
import { fetchExamsSchedule } from '../../../../actions/studentsExamSchedules'
import {
  getExamScheduleForStudent,
  getExamScheduleStatusProps,
} from '../../../../selectors/studentsExamSchedules'
import { isEmpty } from '../../../../utils/common'
import { sortColumnByKey } from '../../../../utils/sort'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const { fetching, error } = getExamScheduleStatusProps(state)
  const { studentId } = selectedApprovalRequest
  return {
    examsSchedule: sortColumnByKey(getExamScheduleForStudent(state, studentId), 'examDate', 'asc'),
    studentId,
    fetching,
    error,
    panelIsOpen,
  }
}

const ExamsSchedule = ({
  studentId,
  examsSchedule,
  panelIsOpen,
  fetching,
  error,
  fetchExamsSchedule,
}) => {
  let output = null
  useEffect(() => {
    if (panelIsOpen && isEmpty(examsSchedule)) {
      fetchExamsSchedule(studentId)
    }
  }, [studentId])

  if (error) {
    output = <Error message={error} />
  }

  if (fetching) {
    output = <Loader />
  }

  if (!isEmpty(examsSchedule)) {
    output = examsSchedule.map((exam, index, exams) => {
      const examCount = exams.length
      return (
        <div style={index + 1 !== examCount ? { marginBottom: '8px' } : {}} key={exam.enrollmentId}>
          <span style={{ display: 'inline-block' }}>
            <DisplayExamDate data={exam} />
          </span>
          <span style={{ display: 'inline-block' }}>{exam.courseName}</span>
        </div>
      )
    })
  }

  return (
    <div className="row">
      <div className="col-xs-12" style={{ paddingBottom: '1.5em' }}>
        {output}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, { fetchExamsSchedule })(ExamsSchedule)
